import React from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useMutation } from '@tanstack/react-query';
import { Container, Form, Button, Segment, Header, Message, Icon } from 'semantic-ui-react';
import { useAuth } from '../contexts/AuthContext';

function DeleteAccount() {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [password, setPassword] = useState('');
  const [confirmText, setConfirmText] = useState('');
  const [error, setError] = useState('');

  const { mutate: deleteAccount, isLoading } = useMutation({
    mutationFn: (data) => Promise.resolve(data), // Replace with actual API call
    onSuccess: () => {
      logout();
      navigate('/');
    },
    onError: (error) => {
      setError(error.message);
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    if (confirmText !== 'DELETE') {
      setError('Please type DELETE to confirm');
      return;
    }

    deleteAccount({ password });
  };

  return (
    <>
      <Helmet>
        <title>Miakara Soap Recipes - Delete Account</title>
      </Helmet>

      <Container>
        <Segment vertical>
          <Header as="h1" color="red">
            <Icon name="warning sign" />
            Delete Account
          </Header>

          <Message warning>
            <Message.Header>Warning: This action cannot be undone</Message.Header>
            <p>
              Deleting your account will permanently remove all your data, including:
            </p>
            <ul>
              <li>Your profile information</li>
              <li>All your recipes</li>
              <li>Forum posts and comments</li>
              <li>Any other content you've created</li>
            </ul>
          </Message>

          <Form onSubmit={handleSubmit} error={!!error}>
            <Form.Input
              label="Current Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <Form.Input
              label="Type DELETE to confirm"
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value)}
              required
            />

            {error && <Message error content={error} />}

            <Button
              type="submit"
              negative
              loading={isLoading}
              disabled={isLoading}
            >
              Delete Account
            </Button>
          </Form>
        </Segment>
      </Container>
    </>
  );
}

export default DeleteAccount; 